module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACuBAMAAAB+XC0hAAAAIVBMVEUAnmD////3fwDKysr+/v7W7+X+69YlrHf4kib3gAL3fQCI4LGZAAAAoElEQVR42u3dMRHAIBAAwZ+JgswkBtKlBQVIwQGykIkBmu8o9hSsg4t6ZFG+XP/s7U71vCOSXVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhb1qErmAXE8v7qGXPTKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/flag_rect_big/19.png
// module id = SHfi
// module chunks = 1